
import io from 'socket.io-client'
import store from '../store/data'
import message from './message'

//const socket = io.connect('https://sockets-ws-secure.breezy.hr:443', {
var SOCKET_SERVER = (process.env.NODE_ENV === 'production') ? 'https://sockets-ws-secure-v10.breezy.hr:443' : (process.env.NODE_ENV === 'mm') ? 'https://sockets-ws-secure-v10-mm.breezy-hire.com' : 'http://localhost:8089'
var socket
// 

const init = socketUrl => {

  if (socketUrl && socketUrl !== 'undefined') {
    SOCKET_SERVER = socketUrl
  }
  console.log(`socketUrl = ${SOCKET_SERVER}`)
 
  socket = io.connect(SOCKET_SERVER, {
    transports: ['polling', 'websocket'],
  })

  socket.on('connect', function(data){
    console.log('socket connected')
  })

  socket.on('authenticationRequest', function(data){
    console.log('authentication requested')
    store.commit('SET_CONNECT', true)
    //let candidate = store.getters.candidate
    //console.log(candidate)
  })

  socket.on('messageToCandidatePosted', function(data) {
    store.commit('UPDATE_CONVERSATION', data)

    // this should be wrapped one day in a plugin or directive or something
    let play = store.getters.play
    let opened = store.getters.opened
    //console.log('play = ' + play)
    if (play) {
      document.querySelector('#ding').play()
    }
    if (!opened) {
      message.send({
        type: 'widget:open',
        payload: {
          open: true
        }
      })
    }
  })

}

const emit = (message) => {
  socket.emit(message)
}


/*socket.on('messageFromCandidatePosted', function(data) {
  store.commit('UPDATE_CONVERSATION', data)
})*/


export default {
  init,
  emit
}


// WEBPACK FOOTER //
// ./src/services/socket.js